import * as Sentry from '@sentry/vue';

import type { App } from 'vue';

export const initSentry = (args: {
  app: App;
  dsn?: string | null;
  deploymentId?: string | null;
}) => {
  const { app, dsn, deploymentId } = args;

  if (dsn == null || dsn === '') {
    return;
  }

  Sentry.init({
    app,
    dsn,
    initialScope: {
      tags: {
        ...(deploymentId != null && deploymentId !== ''
          ? { deployment_id: deploymentId }
          : {}),
      },
    },
  });
};
